import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag-next';
import './index.css'

const app = createApp(App)

app.use(router);
app.use(VueGtag, {
    property: {
        id: 'G-ET6P5CGKHN',
    },
})
app.mount('#app')
